import {
  useResourceImage 
} from "@/hooks/Image/useResourceImage"
import {
  generateSrcset, generateUrl 
} from "@/util/imageUtils"

const ResourceImage = (props) => {
  const {
    alt,
    className,
    handleError,
    handleLoad,
    height,
    resource,
    type = "image-product",
    width,
    widths,
    ratio,
    ...rest
  } = props

  const talonProps = useResourceImage({
    generateSrcset,
    generateUrl,
    height,
    resource,
    type,
    width,
    widths,
    ratio,
  })

  const {
    sizes, src, srcSet 
  } = talonProps
  const dimensionAttributes = {}

  if (typeof height !== "undefined") {
    dimensionAttributes["--height"] = height + "px"
  }

  if (typeof width !== "undefined") {
    dimensionAttributes["--width"] = width + "px"
  }

  // Note: Attributes that are allowed to be overridden must appear before the spread of `rest`.
  return (
    <img
      loading='lazy'
      style={dimensionAttributes}
      {...rest}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      sizes={sizes}
      src={src}
      srcSet={srcSet}
      width={width}
    />
  )
}

export default ResourceImage
